import { AlertCircle, AlertTriangle, CheckCircle, Info, X } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { Message } from '../../../store/message';

interface ToastProps {
  message: Message;
  onClose: () => void;
}

const variants = {
  info: {
    icon: Info,
    className: 'bg-blue-50 text-blue-800 dark:bg-blue-900/30 dark:text-blue-200',
    iconClass: 'text-blue-500 dark:text-blue-400',
  },
  success: {
    icon: CheckCircle,
    className: 'bg-green-50 text-green-800 dark:bg-green-900/30 dark:text-green-200',
    iconClass: 'text-green-500 dark:text-green-400',
  },
  warning: {
    icon: AlertTriangle,
    className: 'bg-yellow-50 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-200',
    iconClass: 'text-yellow-500 dark:text-yellow-400',
  },
  error: {
    icon: AlertCircle,
    className: 'bg-red-50 text-red-800 dark:bg-red-900/30 dark:text-red-200',
    iconClass: 'text-red-500 dark:text-red-400',
  },
};

function Toast({ message, onClose }: ToastProps) {
  const variant = variants[message.variant || 'info'];
  const Icon = variant.icon;

  return (
    <div 
      className={cn(
        'pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg shadow-lg',
        'animate-in slide-in-from-top-4 fade-in duration-300',
        'border border-gray-200 dark:border-gray-700',
        variant.className
      )}
      style={{
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04), 0 0 0 1px rgba(0, 0, 0, 0.1)',
      }}
    >
      <div className="p-4">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <Icon className={cn('h-6 w-6', variant.iconClass)} />
          </div>
          <div className="ml-3 w-0 flex-1">
            <p className="text-sm font-medium">{message.title}</p>
            {message.content && (
              <p className="mt-1 text-sm opacity-90">
                {message.content}
              </p>
            )}
          </div>
          <div className="ml-4 flex flex-shrink-0">
            <button
              type="button"
              className="inline-flex rounded-md opacity-70 hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
              onClick={onClose}
            >
              <span className="sr-only">Fechar</span>
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Toast;